import { CardSliderOptions, Swiper } from './types';
import '@/components/Slider/swiper.scss';
import './CardSliderWidget.scss';

/**
 *
 */
export class CardSliderWidget {
    /**
     *
     */
    static readonly defaultOptions: CardSliderOptions = {
        init: false,
        spaceBetween: 20,
        grabCursor: true,
        slidesPerView: 1.1,
        breakpoints: {
            720: {
                slidesPerView: 2.1,
            },
            960: {
                slidesPerView: 3.1,
            },
            1300: {
                slidesPerView: 4,
            },
        },
    };
    /**
     *
     */
    private readonly settings: CardSliderOptions = {};
    /**
     *
     */
    private slider!: Swiper;
    /**
     *
     */
    constructor(private readonly el: HTMLElement, options?: CardSliderOptions) {
        this.settings = Object.assign({}, CardSliderWidget.defaultOptions, options);
        this.init();
    }
    /**
     *
     */
    private async init() {
        const Swiper = (
            await import(
                /* webpackChunkName: "swiper-js" */
                /* webpackMode: "lazy" */ 'swiper'
            )
        ).default;

        this.slider = new Swiper(this.el, this.settings);
        this.slider.on('init', () => this.onSliderMove());
        this.slider.on('progress', () => this.onSliderMove());
        (this.slider as any).init();
        this.el.classList.add('ready');
    }
    /**
     *
     */
    private onSliderMove() {
        if (this.slider.translate > -10 || this.slider.isBeginning) {
            this.slider.$el.addClass('reach-beginning');
        } else {
            this.slider.$el.removeClass('reach-beginning');
        }

        if (this.slider.isEnd) {
            this.slider.$el.addClass('reach-end');
        } else {
            this.slider.$el.removeClass('reach-end');
        }
    }
}
